// extracted by mini-css-extract-plugin
module.exports = {"wbkyjd7":"wbkyjd7","c1er61zt":"c1er61zt"};